import { createContext, useContext } from "react";
import dayjs, { Dayjs } from "dayjs";

export interface FilterContextValue {
    selectedOrgIds: string[];
    selectedUserIds: string[];
    dateRange: [Dayjs, Dayjs];
    setSelectedOrgIds: (ids: string[]) => void;
    setSelectedUserIds: (ids: string[]) => void;
    setDateRange: (range: [Dayjs, Dayjs]) => void;
}

export const FilterContext = createContext<FilterContextValue | undefined>(
    undefined,
);

export function useFilterContext(): FilterContextValue {
    const ctx = useContext(FilterContext);
    if (!ctx) {
        throw new Error("useFilterContext must be used within a FilterContext.Provider");
    }
    return ctx;
}
